import { render, staticRenderFns } from "./Criteria.vue?vue&type=template&id=24ba91d8&scoped=true"
import script from "./Criteria.vue?vue&type=script&lang=ts"
export * from "./Criteria.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ba91d8",
  null
  
)

export default component.exports